import { makeStyles } from "@mui/styles";
import { fieldContainer, fieldLabel, fieldInput } from "../Form/fieldStyles";

const useStyles = makeStyles(() => ({
  container: { ...fieldContainer, position: "relative" },
  label: fieldLabel,
  dropdown: {
    ...fieldInput,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    position: "relative",
    userSelect: "none",
  },
  dropdownContent: {
    display: "none",
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    marginTop: "4px",
    backgroundColor: "#ffffff",
    boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.12)",
    zIndex: 5,
    borderRadius: "10px",
    overflow: "hidden",
    border: "1px solid #E2E2E2",
    "& div": {
      padding: "12px 14px",
      borderBottom: "1px solid #F0F0F0",
      "&:last-child": { borderBottom: "none" },
      "&:hover": { backgroundColor: "#f7f7f7" },
    },
  },
  show: { display: "block" },
  arrow: { width: "10px", height: "7px", marginLeft: "8px" },
}));

export default useStyles;
